import React from 'react'
import { Link, MenuItem as Item, Icon } from '@chakra-ui/react'
import { Link as RouterLink } from 'react-router-dom'

function MenuItem({ icon, children, show, ...rest }) {
  if (typeof show === 'boolean' && !show) return null
  const isLocalLink = !!rest.to
  return (
    <Item
      as={isLocalLink ? RouterLink : Link}
      target={!isLocalLink ? '_blank' : null}
      rel={!isLocalLink ? 'noreferrer' : null}
      icon={!!icon && <Icon w="15px" fontSize="15px" as={icon} />}
      {...rest}
    >
      {children}
    </Item>
  )
}

export default MenuItem
